export const fonts = {
  text: "Microsoft Sans Serif, sans-serif",
};

export const fontSize = {
  xs: "12px",
  s: "14px",
  m: "16px",
  l: "18px",
  xl: "24px",
  xxl: "30px",
  xxxl: "44px",
};
